import {
    GET_ADMINS_ERROR,
    GET_ADMINS_START,
    GET_ADMINS_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.admins, action = {type: ''}) => {
    switch (action.type) {
        case GET_ADMINS_START:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GET_ADMINS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case GET_ADMINS_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/getAdminsReducer.js